import { createQueryKeyFactory } from '@/utils/queries'

const roleQueryKeys = createQueryKeyFactory(['roles'])

export default {
    ...roleQueryKeys,
}
